
const quotaLoggedKeys = new Set<string>()

const isQuotaExceededError = (error: unknown) => {
    if (typeof DOMException !== 'undefined' && error instanceof DOMException) {
        return error.name === 'QuotaExceededError' || error.name === 'NS_ERROR_DOM_QUOTA_REACHED'
    }

    if (typeof error === 'object' && error !== null && 'name' in error) {
        const name = String((error as { name?: unknown }).name || '')
        return name === 'QuotaExceededError' || name === 'NS_ERROR_DOM_QUOTA_REACHED'
    }

    return false
}

export const LocalStorage = {
    get: <T>(key: string): T | null => {
        try {
            const item = window.localStorage.getItem(key)
            return item ? (JSON.parse(item) as T) : null
        } catch (error) {
            console.error(`Error reading from localStorage key "${key}":`, error)
            return null
        }
    },
    set: <T>(key: string, value: T): boolean => {
        try {
            window.localStorage.setItem(key, JSON.stringify(value))
            quotaLoggedKeys.delete(key)
            return true
        } catch (error) {
            if (isQuotaExceededError(error)) {
                if (!quotaLoggedKeys.has(key)) {
                    quotaLoggedKeys.add(key)
                    console.warn(
                        `localStorage quota exceeded for key "${key}". Falling back to reduced persistence.`
                    )
                }
                return false
            }

            console.error(`Error writing to localStorage key "${key}":`, error)
            return false
        }
    },
    remove: (key: string): void => {
        window.localStorage.removeItem(key)
    },
    clear: (): void => {
        window.localStorage.clear()
    },
}

// Special helpers for common values if needed, or just use LocalStorage.get(STORAGE_KEYS.UI_THEME_MODE)
